import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { forwardRef, RefObject } from 'react'

export interface PillOptionVariantProps {
  label: string
  onClick: (
    e: React.MouseEvent<HTMLLabelElement | HTMLButtonElement, MouseEvent>,
  ) => void
  disabled?: boolean
  selected?: boolean
  children?: React.ReactNode
}

export const PillOptionVariant = forwardRef<
  HTMLLabelElement | HTMLButtonElement,
  PillOptionVariantProps
>((props, ref) => {
  const forwardedRef = ref as RefObject<HTMLButtonElement>

  return (
    <button
      type='button'
      disabled={props.disabled}
      ref={forwardedRef}
      onFocus={() => forwardedRef?.current?.focus()}
      tabIndex={0}
      role='checkbox'
      aria-disabled={props.disabled}
      aria-checked={props.selected}
      onClick={props.onClick}
      className={`px-3 py-1.5 min-w-fit w-full rounded-full text-sm border transition-colors flex items-center gap-2 bg-white ${
        props.selected
          ? 'text-base-1000 border-primary-600'
          : 'text-base-700 border-base-300 hover:border-primary-400'
      }`}>
      {props.selected && (
        <FontAwesomeIcon className='text-primary-600' icon={faCheck} />
      )}
      <span className='min-w-fit'>
        {props.children ? props.children : props.label}
      </span>
    </button>
  )
})
